<template>
  <div class="principal principal--exclusivo-comercio ">
    <div class="contenedor-login contenedor-login--exclusivo-comercio">
      <div class="div-home div-home--exlusivo">
        <a href="https://sumabeneficios.com/">
          <button type="button" class="btn btn-link">
            <img id="cb-logo" src="img/ico-flecha-izq-azul.svg" />
            <span>INICIO</span>
          </button>
        </a>
      </div>
      <div class="body__login-comerciante-exclusivo">
        <div class="logo__login-comerciante">
          <img src="img/logo-ingreso-comercio.svg" alt="logo comercio" />
        </div>
        <div class="inputs__login-comerciante">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="MAIL"
            class="comercio-adherido__login-comerciante"
            @keydown="emailInputKeyDown"
            v-model="model.data.email"
          />
          <input
            type="password"
            v-model="model.data.password"
            id="password"
            name="contraseña"
            placeholder="CONTRASEÑA"
            class="password__login-comerciante password__login-comerciante--exlusivo"
            @keydown="passwordInputKeyDown"
          />
          <button @click="clickLogIn()" class="btn__login-comerciante btn__login-comerciante--exclusivo">
            <img id="cb-logo" src="img/cunia-right.svg" />
            <span>INGRESAR</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./login-cliente-and-comerciante.scss";
import Swal from "sweetalert2";
import { AuthFacade as AuthComercianteFacade } from "../../../service/comerciante/auth/auth.facade";
import { RouteNames as ComercianteRouteNames } from "../../../routes/comerciante.routes";
//import { RouteNames as ClienteRouteNames } from "../../../routes/cliente.routes";

export default {
  components: {},
  data() {
    return {
      model: {
        data: {
          email: undefined,
          password: undefined,
        },
        loggingIn: false,
      },
    };
  },
   async created() {    
    if(this.$route.params.user != null && this.$route.params.password != null){
      try {
        await this.logInWithEmailAndPasswordFunction(
          this.$route.params.user,
          this.$route.params.password,
        );
      } catch (error) {
        this.showError(error);
      }
    }  
  },
  methods: {
    async clickLogIn() {
      if (this.model.loggingIn) return;

      this.model.loggingIn = true;

      try {
        await this.logInWithEmailAndPasswordFunction(
          this.model.data.email,
          this.model.data.password
        );
      } catch (error) {
        console.log(error);
        this.showError(error);
      }

      this.model.loggingIn = false;
    },clickGoBack() {
       this.$router.push({ name: 'InicioLogin' });
    },
    show() {
      this.$refs.modal.abrir();
    },
    showError(error) {
      const status = error.response?.status ?? 0;
      Swal.fire({
        icon: "error",
        title: "Problemas",
        text:
          status == 401
            ? "Usuario y/o contraseña incorrectos"
            : "Error inesperado, código de error: " + status,
        keydownListenerCapture: true,
      });
    },

    emailInputKeyDown(event) {
      if(event.keyCode === 13) {
        this.focusPasswordInput()
      }
    },

    passwordInputKeyDown(event) {
      if(event.keyCode === 13) {
        this.clickLogIn()
      }
    },

    focusPasswordInput() {
      const pwdInput = document.getElementById("password")
      pwdInput.focus();
    },
     async logInWithEmailAndPasswordFunction(email, password) {
      await AuthComercianteFacade.logIn(email, password);
      this.goToComercianteHome();
    },
    goToComercianteHome() {
      this.$router.push({
        name: ComercianteRouteNames.Ventas,
      });
    },
  
  },
};
</script>

<style lang="scss"></style>
